import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private isStorageAvailable(): boolean {
    try {
      const testKey = '__storage_test__';
      window.localStorage.setItem(testKey, 'test');
      window.localStorage.removeItem(testKey);
      return true;
    } catch {
      return false;
    }
  }

  getItem(key: string): string | null {
    if (!this.isStorageAvailable()) {
      return null;
    }
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  setItem(key: string, value: string): void {
    if (!this.isStorageAvailable()) {
      return;
    }
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // swallow
    }
  }

  removeItem(key: string): void {
    if (!this.isStorageAvailable()) {
      return;
    }
    try {
      window.localStorage.removeItem(key);
    } catch {
      // swallow
    }
  }
}
